import React from 'react';

const WelcomeHeader = ({name}) => (
  <h2 className='text-center margin-bottom' style={{marginTop: 0}}>
    Welcome
    {' '}
    {name}
  </h2>
);

export default WelcomeHeader;



// WEBPACK FOOTER //
// ./src/components/Dashboard/WelcomeHeader.js